<template>
  <div><slot></slot></div>
</template>

<script>
import VueScrollTo from "vue-scrollto";

export default {
  mounted() {
    this.$nextTick(() => {
      VueScrollTo.scrollTo(this.$el, this.$props.duration, {
        offset: this.$props.offset,
        onDone: () => this.$emit("done")
      });
    });
  },
  props: {
    duration: {
      type: Number,
      default: 500
    },
    offset: {
      type: Number,
      default: -100
    }
  }
};
</script>
